import { DataService } from 'src/app/services/data.service';
import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  loginText: string;

  constructor(
    private data: DataService
  ) { }

  async ngOnInit() {
    this.data.getSettings('configs').subscribe((res) => {
      if(res && res.data){
        this.loginText = res.data.loginText;
      }
    });
  }

}
